import { POST_REGISTER_START } from '../../types';

export const register = (payload) => ({
  type: POST_REGISTER_START,
  payload,
});
